import { blobticService } from '../../Commun/services/blobticService';

export interface Repair {
    id: number;
    uid?: string;
    vehIdf?: number;
    rprDate?: Date;
    rprGarage?: string;
    rprDescription?: string;
    rprCost?: number;
    rprStatus?: string;
    lastUpdate?: Date;
    userId?: number;
    // Joined vehicle info
    vehRegistration?: string;
    vehBrand?: string;
}

interface RepairDto {
    RPR_IDF: number;
    RPR_UIDF?: string;
    VEH_IDF?: number;
    RPR_DATE?: string;
    RPR_GARAGE?: string;
    RPR_DESCRIPTION?: string;
    RPR_COST?: number;
    RPR_STATUS?: string;
    LAST_UPDT?: string;
    USER_IDF?: number;
    // Joined vehicle info
    VEH_REGISTRATION?: string;
    VEH_BRAND?: string;
}

const mapDtoToModel = (dto: RepairDto): Repair => ({
    id: dto.RPR_IDF,
    uid: dto.RPR_UIDF,
    vehIdf: dto.VEH_IDF,
    rprDate: dto.RPR_DATE ? new Date(dto.RPR_DATE) : undefined,
    rprGarage: dto.RPR_GARAGE,
    rprDescription: dto.RPR_DESCRIPTION,
    rprCost: dto.RPR_COST,
    rprStatus: dto.RPR_STATUS,
    lastUpdate: dto.LAST_UPDT ? new Date(dto.LAST_UPDT) : undefined,
    userId: dto.USER_IDF,
    vehRegistration: dto.VEH_REGISTRATION,
    vehBrand: dto.VEH_BRAND
});

export const getRepairs = async (params?: any) => {
    let actionParams: any = { OKey: 'Blobtic_Parc,parc_repair,select' };

    if (params) {
        const { searchParams, ...restParams } = params;
        if (searchParams) {
            actionParams = { ...actionParams, ...searchParams };
        }
        actionParams = { ...actionParams, ...restParams };
    }

    actionParams.joins = '[{"Table":"TABP_PARC_VEHICLE","Alias":"V","On":"TABP_PARC_REPAIR.VEH_IDF = V.VEH_IDF","Type":"LEFT"}]';
    actionParams.fields = 'TABP_PARC_REPAIR.*, V.VEH_REGISTRATION as veh_registration, V.VEH_BRAND as veh_brand';

    const response = await blobticService.executeZoomRequest({
        ZoomKey: 'Blobtic_Parc',
        Action: actionParams
    });

    if (response.success && Array.isArray(response.data)) {
        return response.data.map((item: any) => mapDtoToModel(item));
    }
    throw new Error(response.message || 'Failed to fetch repairs');
};

export const createRepair = async (data: Partial<Repair>) => {
    const payload: any = {
        OKey: 'Blobtic_Parc,parc_repair,insert',
        VEH_IDF: data.vehIdf,
        RPR_DATE: data.rprDate?.toISOString(),
        RPR_GARAGE: data.rprGarage,
        RPR_DESCRIPTION: data.rprDescription,
        RPR_COST: data.rprCost,
        RPR_STATUS: data.rprStatus
    };
    const response = await blobticService.executeZoomRequest({
        ZoomKey: 'Blobtic_Parc',
        Action: payload
    });

    if (response.success && response.data && (response.data as any[]).length > 0) {
        return mapDtoToModel((response.data as any[])[0]);
    }
    throw new Error(response.message || 'Failed to create repair');
}

export const updateRepair = async (id: number, data: Partial<Repair>) => {
    const payload: any = {
        OKey: 'Blobtic_Parc,parc_repair,update',
        RPR_IDF: id,
        VEH_IDF: data.vehIdf,
        RPR_DATE: data.rprDate?.toISOString(),
        RPR_GARAGE: data.rprGarage,
        RPR_DESCRIPTION: data.rprDescription,
        RPR_COST: data.rprCost,
        RPR_STATUS: data.rprStatus
    };
    const response = await blobticService.executeZoomRequest({
        ZoomKey: 'Blobtic_Parc',
        Action: payload
    });

    if (response.success && response.data && (response.data as any[]).length > 0) {
        return mapDtoToModel((response.data as any[])[0]);
    }
    throw new Error(response.message || 'Failed to update repair');
};

export const deleteRepair = async (id: number) => {
    const response = await blobticService.executeZoomRequest({
        ZoomKey: 'Blobtic_Parc',
        Action: { OKey: 'Blobtic_Parc,parc_repair,delete', RPR_IDF: id }
    });

    if (!response.success) {
        throw new Error(response.message || 'Failed to delete repair');
    }
    return response;
};

export const repairsApi = {
    getRepairs,
    createRepair,
    updateRepair,
    deleteRepair
};
